import React from "react";
import { Alert, Snackbar } from "@mui/material";
import { useUI } from "../contexts/UIContext";

export default function NotificationCenter() {
  const { notification, closeNotification } = useUI();
  const isError = notification.severity === "error";

  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={4500}
      onClose={closeNotification}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        variant="filled"
        severity={notification.severity}
        onClose={closeNotification}
        sx={{
          width: "100%",
          ...(isError
            ? {
                bgcolor: "#021423",
                color: "#ff0000",
                "& .MuiAlert-icon": {
                  color: "#7cb11a",
                },
                "& .MuiAlert-action": {
                  color: "#7cb11a",
                },
              }
            : {}),
        }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
